import React from 'react';
import { Box, Text, styled } from '@goodrx/matisse';
import { CoreLinkProps } from 'app/components/core/CoreLink/CoreLink';

import { UniversalLink } from 'app/components/links/UniversalLink';
import { HeaderTheme } from '../MarketingHeader/HeaderTheme';

interface PrimaryNavTextProps {
  isActive: boolean;
  headerTheme?: HeaderTheme;
}
const PrimaryNavText = styled(Text)<PrimaryNavTextProps>`
  padding: 0 4px;

  ${({ isActive, headerTheme, theme }) => {
    const useColor = headerTheme === 'dark' ? theme.colors.white : theme.colors.primary;

    if (isActive) {
      return `
        color: ${useColor};
        border-bottom: 2px solid ${useColor};
      `;
    }

    return `&:hover {
      color: ${useColor};
      border-bottom: 2px solid ${useColor};
    }`;
  }}
`;

interface PrimaryNavProps extends CoreLinkProps {
  href: string;
  children: string;
  headerTheme?: HeaderTheme;
}

export const PrimaryMarketingNav = ({ children, href, headerTheme, ...linkProps }: PrimaryNavProps) => {
  const isActive = typeof window !== 'undefined' && window?.location?.pathname?.indexOf(href) === 0;

  return (
    <Box mr={3}>
      <UniversalLink href={href} {...linkProps}>
        <PrimaryNavText headerTheme={headerTheme} isActive={isActive}>
          {children}
        </PrimaryNavText>
      </UniversalLink>
    </Box>
  );
};
